module.exports = __webpack_public_path__ + "img/austria-blood-diseases-female.97b832e3.png";